export const api="https://api.555mix.com/api";

// export const api="http://18.166.215.128:8080/api";